import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import {
  Button,
  Header,
  Segment,
  Form,
  Grid,
  Input,
  Select,
  TextArea,
  Icon
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import HistoryTable from '../Details/HistoryDetails/HistoryTable';
import OrderTable from '../Details/OrderTable';
import DeleteConfirmation from '../../../app/common/modals/DeleteConfirmation';
import '../../../app/common/MediaQuery/responsive-view-page.css';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import agent from '../../../app/api/agent';
import Components from '../../../app/common/components';
import { isArray } from 'lodash';
import { FileType } from '../Details/FileUpload';
import CamModal, { PhotoType } from '../Details/CamModal';
import { FileUploadInterface } from '../../../app/models/Profile';
import UnauthorizedMessage from '../../UnauthorizedMessage';
import { GetCurrentUser } from '../../../app/models/user';
import { columnType } from '../../../app/common/components/DynamicRowsComponent';
import { PDFDownloadLink } from '@react-pdf/renderer';
import TagVerifyPDF from '../../Dashboard/Receiving/TagVerifyPDF';
import { uploadFileType } from '../../../app/api/types';
import { optionsInterface } from '../../../app/models/tabverify';

export default observer(function ActivityForm() {
  const history = useNavigate();
  const location = useLocation();
  const {
    activityStore,
    vaultStore,
    modalStore,
    dashboardStore,
    userStore,
    mediaAssetStore,
    commonStore,
    userStore: { user },
    RolesAndPermissionsIDStore,
    viewStore: { getActiveOrder },
    ElementStore: { generatePdf },
    receivingdeliveryStore: {
      loadReceivingDelivery,
      selectedReceivingDelivery,
    },
  } = useStore();
  const { loadRoleIDS } = RolesAndPermissionsIDStore;
  const {
    collectMetaData,
    collectMetaDataHFC,
    metaDataVal,
    // viewTemplateOrderDetails,
    updateMetaData,
    createManageDetailsAPI,
    loadActivity,
    selectedActivity,
  } = activityStore;
  // const selectedUserId = dashboardStore.dashboard.selectedUserRoleId;
  const {
    vaultList,
    getVaultList,
    getRackList,
    rackList,
    getShelfList,
    shelfList,
    getPigeonList,
    pigeonList,
  } = vaultStore;
  const { id } = useParams<{ id: string }>();
  const [localMetaData, setLocalMetaData] = useState<any>({});
  const [isEditForm, setIsEditForm] = useState(false);
  const [selectedId, setSelectedId] = useState<string | undefined>();
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [parentTitle, setParentTitle] = useState<string>('');
  const [parentTitleSingle, setParentTitleSingle] = useState<string>('');
  const [mastersList, setMasterList] = useState<any>({});
  const [userList, setUserList] = useState<any>({});
  const [photoIndex, setPhotoIndex] = useState(0);
  const [camImage, setCamImage] = useState<FileUploadInterface[]>([]);

  const [dataGridHeaders, setDataGridHeaders] = useState<any[]>([]);
  const [dataGridInitialValue, setDataGridInitialValue] = useState<any[]>([]);

  const [removedRow, setRemovedRow] = useState<any>();
  const [addedRow, setAddedRow] = useState<any>();
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const [metadataExistence, setMetadataExistence] = useState<string[]>([]);
  const [technicalExistence, setTechnicalExistence] = useState<string[]>([]);
  const [metadataValueUpdate, setMetadataValueUpdate] = useState<any[]>([]);

  const [titleProcessDates, setTitleProcessDates] = useState<{
    elementId: string;
    elementName: string;
    fromDate: string;
    toDate: string;
  }[]>([]);

  const convertDateInputToIso = (value: string) => {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString();
  };

  const handleTitleProcessDateChange = (
    elementId: string,
    field: 'fromDate' | 'toDate',
    value: string,
  ) => {
    setTitleProcessDates((current) =>
      current.map((item) =>
        item.elementId === elementId ? { ...item, [field]: value } : item,
      ),
    );
  };

  const [vaultOptions, setVaultOptions] = useState<optionsInterface[]>([]);
  const [rackOptions, setRackOptions] = useState<optionsInterface[]>([]);
  const [roomOptions, setRoomOptions] = useState<optionsInterface[]>([]);
  const [aisleOptions, setAisleOptions] = useState<optionsInterface[]>([]);
  const [shelfOptions, setShelfOptions] = useState<optionsInterface[]>([]);
  const vaultId = useRef<string>('');

  const [tagPDFData, setTagPDFData] = useState<{
    Title: string;
    'Element Type': string;
    'Vault Location': string;
    'Physical Case Count': number;
    Description: string;
    Barcode: string;
  }>({
    Title: '',
    'Element Type': '',
    'Vault Location': '',
    'Physical Case Count': 0,
    Description: '',
    Barcode: '',
  });

  const mandatoryFieldsRef = useRef<any>({});
  const [isMaster, setIsMaster] = useState(false);

  useEffect(() => {
    if (selectedActivity) {
      let tempTagData = {
        ...tagPDFData,
        Title:
          selectedActivity.title?.split(' - ')?.[0] +
          ' ~ ' +
          selectedActivity.title?.split('~')?.[1],
        'Element Type': selectedActivity.type,
        'Vault Location': selectedActivity.physical_location_vault,
        'Physical Case Count': selectedActivity.calculated_category,
        Barcode: selectedActivity.physical_sensor_barcode,
      };
      setTagPDFData(tempTagData);
    }
    // eslint-disable-next-line
  }, [selectedActivity]);


  useEffect(()=>{
   vaultStore.getHFCVaultList()
    // eslint-disable-next-line
  },[])

  useEffect(() => {
    const fetchRoomOptions = async () => {
        if (localMetaData.vault !== "") {
            const filteredArray:any = [];
            vaultStore.HFCvaultList.forEach((x: any) => {
                if (x.value === localMetaData.vault) {
                    filteredArray.push(x);
                }
            });

            if (filteredArray.length > 0) {
                try {
                    const res = await agent.HFC.HFCRoom(filteredArray[0].key);
                    const roomOptions = res.data.map((vault: any, index: any) => {
                        return {
                            key: index,
                            value: vault,
                            text: vault,
                        };
                    });
                    setRoomOptions(roomOptions);
                } catch (error) {
                    console.error("Error fetching room options:", error);
                }
            } else {
                console.log("No matching vault found.");
            }
        }
        if(localMetaData.vault === ""){
          localMetaData.room = ""
          localMetaData.aisle_No = ""
          localMetaData.shelf = ""
          setLocalMetaData({...localMetaData})
        }
    };

    fetchRoomOptions();
    // eslint-disable-next-line
}, [localMetaData.vault])

useEffect(() => {
  const fetchAisleOptions = async () => {
      if (localMetaData.vault !== "") {
          const filteredArray:any = [];
          vaultStore.HFCvaultList.forEach((x: any) => {
              if (x.value === localMetaData.vault) {
                  filteredArray.push(x);
              }
          });

          if (filteredArray.length > 0) {
              try {
                  const res = await agent.HFC.HFCAisle(filteredArray[0].key, localMetaData.room);
                  const AisleOptions = res.data.map((vault: any, index: any) => {
                      return {
                          key: index,
                          value: vault,
                          text: vault,
                      };
                  });
                  setAisleOptions(AisleOptions);
              } catch (error) {
                  console.error("Error fetching room options:", error);
              }
          } else {
              console.log("No matching vault found.");
          }
      }
  };

  fetchAisleOptions();
    // eslint-disable-next-line
}, [localMetaData.room]);

useEffect(() => {
  const fetchShelfOptions = async () => {
      if (localMetaData.vault !== "") {
          const filteredArray:any = [];
          vaultStore.HFCvaultList.forEach((x: any) => {
              if (x.value === localMetaData.vault) {
                  filteredArray.push(x);
              }
          });

          if (filteredArray.length > 0) {
              try {
                  const res = await agent.HFC.HFCShelf(filteredArray[0].key, localMetaData.room, localMetaData.aisle_No);
                  const shelfOptions = res.data.map((vault: any, index: any) => {
                      return {
                          key: index,
                          value: vault,
                          text: vault,
                      };
                  });
                  setShelfOptions(shelfOptions);
              } catch (error) {
                  console.error("Error fetching room options:", error);
              }
          } else {
              console.log("No matching vault found.");
          }
      }
  };

  fetchShelfOptions();
    // eslint-disable-next-line
}, [localMetaData.aisle_No]);

  useEffect(() => {
    if (selectedReceivingDelivery?.receiver_Description) {
      let tempTagData = {
        ...tagPDFData,
        Description: selectedReceivingDelivery.receiver_Description,
      };
      setTagPDFData(tempTagData);
    }
    // eslint-disable-next-line
  }, [selectedReceivingDelivery?.receiver_Description]);

  useEffect(() => {
    if (vaultList.length === 0) getVaultList();
  }, [vaultList.length, getVaultList]);

  useEffect(() => {
    if (vaultList.length > 0) {
      const tempVaultOptions = vaultList.map((v) => {
        return {
          key: v.id,
          text: v.name,
          value: v.name,
        };
      });
      setVaultOptions(tempVaultOptions);
    } else {
      setVaultOptions([]);
      setRackOptions([]);
      setShelfOptions([]);
    }
    // eslint-disable-next-line
  }, [vaultList]);

  useEffect(() => {
    if (id) {
      loadActivity(id);
      getActiveOrder({ itemId: id });
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (selectedActivity?.element === 'TitleProcess') {
      setTitleProcessDates([
        {
          elementId: selectedActivity.id || '',
          elementName: 'TitleProcess',
          fromDate: '',
          toDate: '',
        },
      ]);
    } else {
      setTitleProcessDates([]);
    }
  }, [selectedActivity?.element, selectedActivity?.id]);

  useEffect(() => {
    if (selectedActivity?.registerId) {
      loadReceivingDelivery(selectedActivity?.registerId || '');
    }
  }, [selectedActivity?.registerId, loadReceivingDelivery]);

  useEffect(() => {
    loadRoleIDS();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCamImage(dashboardStore.dashboard.camImageUrl);
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.camImageUrl]);

  useEffect(() => {
    (async () => {
      if (id) {
        let result = await agent.MetaDataAssetTypes.searchisMasterAPI(id);
        if (result) {
          setIsMaster(!!result?.length);
        }
        if (location.pathname.match('create')) {
          setIsMaster(true);
        }
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    function compare(a: { elementIndex: number }, b: { elementIndex: number }) {
      if (a.elementIndex < b.elementIndex) {
        return -1;
      }
      if (a.elementIndex > b.elementIndex) {
        return 1;
      }
      return 0;
    }

    if (metaDataVal && JSON.parse(JSON.stringify(metaDataVal))) {
      let copy = JSON.parse(JSON.stringify(metaDataVal))?.metadata?.sort(
        compare,
      );
      let metadataCopy = {
        ...metaDataVal,
        metadata: copy,
      };

      // masters
      let mastersHashmap: any = {};
      const mastersListOptions = async (
        masterId: string,
        componentName: string,
      ) => {
        const payload = {
          name: masterId,
          componentName,
          filterColumn: '',
          filterValue: '',
          receivingDate: '',
          returnDate: '',
        };
        let result: any = await agent.WorkLevels.mastersListAPI(payload);
        let returnData = (result?.data || [])?.map((data: string) => {
          return {
            key: data,
            value: data,
            text: data,
          };
        });
        return returnData;
      };
      let filterMasters = metadataCopy?.metadata?.filter(
        (data: { elementType: string; selectMasterComponent: string }) =>
          data.elementType === 'Masters',
      );
      filterMasters?.forEach(
        async (data: {
          elementValue: string;
          selectMasterComponent: string;
        }) => {
          let result = await mastersListOptions(
            data.elementValue?.split('|')?.[0],
            data.selectMasterComponent,
          );
          mastersHashmap[
            `${data.elementValue?.split('|')?.[0] || data.elementValue}`
          ] = result;
          setMasterList(mastersHashmap);
        },
      );

      // users
      let usersHashmap: any = {};
      const usersListOptions = async (userId: string) => {
        let result: any = await agent.WorkLevels.usersListAPI(userId);
        let returnData = await (result || [])?.map((data: string) => {
          return {
            key: data,
            value: data,
            text: data,
          };
        });
        return returnData;
      };
      let filterUsers = metadataCopy?.metadata?.filter(
        (data: { elementType: string }) => data.elementType === 'Users',
      );
      filterUsers?.forEach(async (data: { elementValue: string }) => {
        let result = await usersListOptions(data.elementValue?.split('|')?.[0]);
        usersHashmap[`${data.elementValue?.split('|')?.[0]}`] = result;
        setUserList(usersHashmap);
      });
      setLocalMetaData(metadataCopy);
    }
  }, [metaDataVal]);

  useEffect(() => {
    if (window.location?.pathname.match('create')) {
      if (id) {
        activityStore.getItemPropertyDetailsAPI(id);
      }
      setIsEditForm(false);
    } else {
      if (commonStore.hfcCustomerChanges) {
        collectMetaDataHFC(id).then((response) => {
          // Assuming response contains metadata
          setMetadataValueUpdate(response?.metadata);
        });
      } else {
        collectMetaData(id).then((response) => {
          setMetadataValueUpdate(response?.metadata);
        });
      }
      setIsEditForm(true);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    returnTitleFunctionForParent(
      localMetaData.sections_Multiple_From,
      'Multiple',
    );
  }, [localMetaData.sections_Multiple_From]);

  useEffect(() => {
    returnTitleFunctionForParent(localMetaData.sections_From, 'Single');
  }, [localMetaData.sections_From]);

  useEffect(() => {
    let errorMessageLocal: any = {};
    metaDataVal?.metadata?.forEach((metadata: any) => {
      let {
        readOnly,
        enableByDefault,
        elementType,
        elementValue,
        elementId,
        validation,
        isMandatory,
        files,
        photos,
      } = metadata || {};

      if (readOnly || !enableByDefault) return;

      let result = '';
      if (/textbox/gi.test(elementType) && elementValue) {
        result = commonStore.genericValidation(
          elementValue || '',
          validation || '',
        );
      }

      if (result?.length) {
        errorMessageLocal[`${elementId}`] = result;
      } else if (
        (elementType === 'AddFiles' && isMandatory && files.length === 0) ||
        (elementType === 'AddPhotograph' && isMandatory && photos.length === 0)
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        elementValue?.length === 0 &&
        elementType !== 'AddFiles' &&
        elementType !== 'AddPhotograph'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else if (
        isMandatory &&
        !elementValue?.split('|')?.[1] &&
        elementType === 'Masters'
      ) {
        errorMessageLocal[`${elementId}`] = 'This is a mandatory field';
      } else {
        delete errorMessageLocal[`${elementId}`];
      }

      /**
       * Mandatory
       */

      if (
        (elementType === 'AddFiles' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          files.length === 0) ||
        (elementType === 'AddPhotograph' &&
          (/mandatory/gi.test(validation) || isMandatory) &&
          photos.length === 0)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        elementType !== 'AddPhotograph' &&
        elementType !== 'AddFiles' &&
        elementValue?.length === 0 &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else if (
        (elementType === 'Users' || elementType === 'Masters') &&
        elementValue?.split('|')?.[1] === undefined &&
        (/mandatory/gi.test(validation) || isMandatory)
      ) {
        mandatoryFieldsRef.current[`${elementId}`] = elementId;
      } else {
        delete mandatoryFieldsRef.current[`${elementId}`];
      }

      setErrorMessage(errorMessageLocal);
    });
    // eslint-disable-next-line
  }, [metaDataVal?.metadata]);

  const handleDeleteActivity = () => {
    // ElementStore?.getTotalCountsOfTask(activeOrder.templateId || '');
    if (localMetaData.title && localMetaData.id) {
      modalStore.openModal(
        <DeleteConfirmation
          type="activity"
          name={localMetaData.title}
          data={localMetaData}
        />,
      );
    }
  };

  useEffect(() => {
    if (rackList.length > 0) {
      const tempRack = rackList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setRackOptions(tempRack);
    } else {
      setRackOptions([]);
      setShelfOptions([]);
    }
    // eslint-disable-next-line
  }, [rackList]);

  useEffect(() => {
    if (shelfList.length > 0) {
      const tempShelf = shelfList?.map((x) => ({
        key: x,
        text: x,
        value: x,
      }));
      setShelfOptions(tempShelf);
    } else {
      setShelfOptions([]);
    }
    // eslint-disable-next-line
  }, [shelfList]);

  useEffect(() => {
    if (localMetaData.physical_location_vault && vaultList.length > 0) {
      const tempLocal = vaultList.filter(
        (vaultdata) => vaultdata.name === localMetaData.physical_location_vault,
      );
      getRackList({ vaultId: tempLocal[0]?.id });
      vaultId.current = tempLocal[0]?.id;
    }
    // eslint-disable-next-line
  }, [localMetaData.physical_location_vault, vaultList]);

  useEffect(() => {
    if (localMetaData.physical_location_rack && vaultId.current !== '') {
      getShelfList({
        vaultId: vaultId.current,
        rackNo: localMetaData.physical_location_rack,
      });
    }
    // eslint-disable-next-line
  }, [localMetaData.physical_location_rack, vaultId.current]);

  useEffect(() => {
    getPigeonList();
  }, [getPigeonList]);

  const collectFormInput = (e: any, data: any) => {
    mediaAssetStore.mediaAsset.assetformhistorydefaultValue = data.defaultValue;
    mediaAssetStore.mediaAsset.assetformhistoryplaceholder = data.placeholder;
    mediaAssetStore.mediaAsset.assetformhistoryValue = data.value;
    let copyMetadataDetails: any = Object.assign({}, localMetaData);
    if (copyMetadataDetails[data.id] !== undefined) {
      copyMetadataDetails[data.id] = data.value;
    }
    if (data.id === 'physical_location_vault') {
      setSelectedId(data.value);
      const gpsDataLocal = vaultList.filter(
        (vaultdata) => vaultdata.name === data.value,
      );
      copyMetadataDetails.global_positioning_system =
        gpsDataLocal[0]?.gpsLocation;
      copyMetadataDetails.physical_location_vault = data.value;
      copyMetadataDetails.physical_location_rack = '';
      copyMetadataDetails.physical_location_shelf = '';
      setShelfOptions([]);
    } else if (data.id === 'physical_location_rack') {
      setShelfOptions([]);
      copyMetadataDetails.physical_location_rack = data.value;
      copyMetadataDetails.physical_location_shelf = '';
    }
    setLocalMetaData(copyMetadataDetails);
  };

  const collectSelectVal = (e: any, data: any) => {
    if (e.keyCode === 'Backspace' || e.keyCode === 'Delete') {
      e.stopPropagation();
      return;
    }
    let copy: any = [...localMetaData.metadata];
    if (e.target.className === 'delete icon') {
      for (let i = 0; i < copy?.length; i++) {
        let linkID = '';
        for (let j = 0; j < copy[i].options?.length; j++) {
          if (
            e.currentTarget.parentElement.text ===
            copy[i]?.options?.[j]?.optionName
          ) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
        }
        let newLinkId = linkID?.split('|');
        for (let x = 0; x < newLinkId?.length; x++) {
          let foundIndex = copy.findIndex(
            (data: { templateElementId: string }) =>
              newLinkId[x] === data.templateElementId,
          );
          if (copy?.[foundIndex] !== undefined) {
            delete mandatoryFieldsRef.current[
              `${copy?.[foundIndex]?.elementId}`
            ];
            copy[foundIndex].enableByDefault = false;
          }
        }
      }

      for (let i = 0; i < copy?.length; i++) {
        let linkID = '';
        if (copy[i].elementName === data.name) {
          let value = '';
          if (isArray(data.value)) {
            value = data.value.join('|');
          } else {
            value = data.value;
          }
          copy[i].elementValue = value;
        }
        for (let j = 0; j < copy[i]?.options?.length; j++) {
          if (data.value?.includes(copy[i]?.options?.[j]?.optionName)) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
          let newLinkId = linkID?.split('|');
          for (let x = 0; x < newLinkId?.length; x++) {
            let foundIndex = copy.findIndex(
              (data: { templateElementId: string }) => {
                return newLinkId[x] === data.templateElementId;
              },
            );
            if (copy?.[foundIndex] !== undefined) {
              if (
                copy?.[foundIndex].isMandatory &&
                copy?.[foundIndex]?.elementValue?.length === 0
              ) {
                mandatoryFieldsRef.current[`${copy?.[foundIndex].elementId}`] =
                  copy?.[foundIndex].elementId;
              }
              copy[foundIndex].enableByDefault = true;
            }
          }
        }
      }
    } else {
      for (let i = 0; i < copy?.length; i++) {
        let linkID = '';

        if (copy[i].elementName === data.name) {
          let value = '';
          if (isArray(data.value)) {
            value = data.value.join('|');
          } else {
            value = data.value;
          }
          copy[i].elementValue = value;
        }
        for (let j = 0; j < copy[i]?.options?.length; j++) {
          if (data.value?.includes(copy[i]?.options?.[j]?.optionName)) {
            linkID = copy[i]?.options?.[j]?.optionLinkId;
          }
          let newLinkId = linkID?.split('|');
          for (let x = 0; x < newLinkId?.length; x++) {
            let foundIndex = copy.findIndex(
              (data: { templateElementId: string }) => {
                return newLinkId[x] === data.templateElementId;
              },
            );
            if (copy?.[foundIndex] !== undefined) {
              if (
                copy?.[foundIndex]?.isMandatory &&
                copy?.[foundIndex]?.elementValue?.length === 0
              ) {
                mandatoryFieldsRef.current[`${copy?.[foundIndex].elementId}`] =
                  copy?.[foundIndex].elementId;
              }
              copy[foundIndex].enableByDefault = true;
            }
          }
        }
      }
    }
    setLocalMetaData((p: any) => ({
      ...p,
      metadata: copy,
    }));
  };

  const collectSelectInpVal = (e: any, data: any, validationData?: any) => {
    let copyMetadataDetails: any = Object.assign({}, localMetaData);
    let indexOfData = copyMetadataDetails?.metadata?.findIndex(
      (localData: { templateElementId: string }) =>
        localData.templateElementId === validationData.templateElementId,
    );
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let value = /datepicker/gi.test(validationData?.elementType || '')
      ? e?.toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        })
      : validationData?.elementType === 'DateTime'
        ? new Date(data).toDateString() +
          ' ' +
          new Date(data).toString().split(' ')[4]
        : data.value;
    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: value,
    };
    if (indexOfData < 0) {
      copyMetadataDetails?.metadata.push(payload);
    } else {
      if (copyMetadataDetails.metadata[indexOfData]) {
        copyMetadataDetails.metadata[indexOfData] = payload;
      }
    }
    setLocalMetaData(copyMetadataDetails);

    if (/textbox/gi.test(validationData?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        validationData?.validation || '',
      );
    }
    if (/dropdown/gi.test(validationData?.elementType || '')) {
      collectSelectVal(e, data);
    }
    if (validationData.isMandatory && !value?.length) {
      result = 'This is mandory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }

    setErrorMessage(errorTemp);
  };
  const [loadingType, setLoadingType] = useState<string | null>(null);
  const updateMetaDataHandler = (id: string) => {
     setLoadingType('update');
    let p1 = new Promise(async (resolve) => {
     await activityStore.updateActivityMetaData(id);
      resolve('');
    });
    p1.then(() => {
      activityStore.updatemetadataHeadersPostItemID(id);
      toast.success('file uploaded successfully');
      setTimeout(() => {
        setLoadingType(null);
      }, 5000);
    });
  };

  const cancelHandler = () => {
    if (isMaster) {
      history(`/mastersreport/${isMaster}`);
    } else {
      history(`/mediaAssets/${localMetaData.id}`);
    }
  };

  const workflowHistoryHandler = (
    elements: {
      id: any;
      description: string;
      values: string;
      type: string;
    }[],
    removedRow: any,
    addedRow: any,
    initialElementValue: any,
    headers: any,
  ) => {
    elements?.forEach(async (element) => {
      let name = '';
      if (element.values?.toString()?.split(',')?.[1]) {
        name = element.values?.toString()?.split(',')?.[1];
      } else {
        name = element.values?.toString()?.split(',')?.[0];
      }
      let status = '';
      if (element.type === 'AddFiles') {
        status = `uploaded file(s) under field "${element.description}" for`;
      } else if (element.type === 'AddPhotograph') {
        status = `uploaded photo(s) under field "${element.description}" for`;
      } else if (element.type === 'Users') {
        status = `updated field "${element.description}" to "${name}" for`;
      } else if (element.type === 'DynamicTable') {
        if (removedRow[element.id]) {
          removedRow[element.id]?.forEach((data: any) => {
            delete data?._uuid_;
            commonStore.updateHistoryAlonePOST(
              `${userStore.user?.displayName} removed record ${JSON.stringify(
                data,
              )
                .split('_')
                ?.join(' ')} from table: ${
                element.description
              } for ${activityStore.selectedActivity?.title}`,
              activityStore.selectedActivity?.id,
              completeHandler,
              false,
              true,
            );
          });
        }
        if (addedRow[element.id]) {
          addedRow[element.id]?.forEach((data: any) => {
            delete data?._uuid_;
            commonStore.updateHistoryAlonePOST(
              `${userStore.user?.displayName} added record ${JSON.stringify(
                data,
              )
                .split('_')
                ?.join(' ')} to table: ${
                element.description
              } for ${activityStore.selectedActivity?.title}`,
              activityStore.selectedActivity?.id,
              completeHandler,
              false,
              true,
            );
          });
        }
        initialElementValue?.[element.id]?.forEach((data: any) => {
          const stringData = element.values?.split('DynamicTable|')?.[1];
          let tempValue =
            stringData !== undefined ? JSON.parse(stringData) : [];
          tempValue?.forEach((alteredData: any, index: number) => {
            headers?.[element.id]?.forEach((column: columnType) => {
              if (
                column.optionName !== '_uuid_' &&
                data[`_uuid_`] === alteredData[`_uuid_`]
              ) {
                let flag = 0;
                if (typeof data[column.optionName] === 'object') {
                  if (
                    JSON.stringify(data[column.optionName]) !==
                    JSON.stringify(alteredData[column.optionName])
                  ) {
                    flag = 1;
                  }
                } else {
                  if (
                    data[column.optionName] !== alteredData[column.optionName]
                  ) {
                    flag = 1;
                  }
                }
                if (flag) {
                  const alterHistory = `${userStore.user
                    ?.displayName} altered record in table: ${element?.description} from "${
                    data[column?.optionName]
                  }" to "${
                    alteredData[column?.optionName]
                  }" under ${column?.optionName
                    ?.split('_')
                    ?.join(' ')} in record (${index + 1}) for ${activityStore
                    .selectedActivity?.title}`;
                  commonStore.updateHistoryAlonePOST(
                    alterHistory,
                    activityStore.selectedActivity?.id,
                    completeHandler,
                    false,
                    true,
                  );
                }
              }
            });
          });
        });
      } else {
        name = element.type === 'DropDown' ? name.split('|').join(',') : name;
        if (element.description === 'calculated_category') {
          status = `set physical_case_count as "${name}" for`;
        } else {
          status = `set "${element.description}" as "${name}" for`;
        }
      }
      if (element.type !== 'DynamicTable') {
        commonStore.updateHistoryAlonePOST(
          `${userStore.user?.displayName} ${status} ${activityStore.selectedActivity?.title}`,
          activityStore.selectedActivity?.id,
          completeHandler,
          false,
          true,
        );
      }
    });
  };

  const saveDynamicTableData = async (
    data: any,
    validationData: any,
    removed: any,
    added: any,
    // alterHistory: string,
    initialElementValue: any,
    headers: columnType[],
  ) => {
    let copyElements = [...localMetaData.metadata];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let payload = {
      ...validationData,
      elementValue: 'DynamicTable|' + JSON.stringify(data),
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    setLocalMetaData({
      ...localMetaData,
      metadata: copyElements,
    });
    if (removed.length > 0) {
      let temp = removedRow || [];
      temp[validationData?.elementId] = removed;
      setRemovedRow(temp);
    }
    if (added.length > 0) {
      let temp = addedRow || [];
      temp[validationData?.elementId] = added;
      setAddedRow(temp);
    }
    // if (alterHistory !== '') {
    //   let temp = [...alteredRowHistory];
    //   temp[validationData?.elementId] = alterHistory;
    //   setAlteredRowHistory(temp);
    // }

    if (headers) {
      const tempValue = dataGridHeaders;
      tempValue[validationData?.elementId] = [...headers];
      setDataGridHeaders(tempValue);
    }

    if (initialElementValue) {
      const tempValue = dataGridInitialValue;
      tempValue[validationData?.elementId] = [...initialElementValue];
      setDataGridInitialValue(tempValue);
    }
  };

  const mastersAndUsersHandler = (_e: any, data: any) => {
    // let errorMessageTemp = {...errorMessage};
    let copyElements = [...localMetaData.metadata];
    let findIndex = copyElements?.findIndex(
      (localData) => localData.elementName === data.name,
    );
    let masterOrUser = copyElements[findIndex].elementValue?.split('|');
    if (copyElements[findIndex]?.elementName === data.name) {
      let name = masterOrUser?.[0];
      let value = data.value;
      value = `${name}|${value}`;
      copyElements[findIndex].elementValue = value;
    }

    if (masterOrUser) {
      delete mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`];
    } else {
      mandatoryFieldsRef.current[`${copyElements[findIndex].elementId}`] =
        copyElements[findIndex].elementId;
    }

    setLocalMetaData((p: any) => ({
      ...p,
      metadata: copyElements,
    }));
  };
  const submitTitleProcessData = async (
    itemId: string,
    fields: {
      elementId: string;
      elementName: string;
      fromDate: string;
      toDate: string;
    }[],
  ) => {
    if (!fields?.length) return;

    for (const field of fields) {
      if (!field.fromDate || !field.toDate) {
        throw new Error(
          `Please select both From Date and To Date for "${field.elementName}"`,
        );
      }

      if (
        new Date(field.fromDate).getTime() >
        new Date(field.toDate).getTime()
      ) {
        throw new Error(
          `To Date should be greater than or equal to From Date for "${field.elementName}"`,
        );
      }

      const fromDate = convertDateInputToIso(field.fromDate);
      const toDate = convertDateInputToIso(field.toDate);
      if (!fromDate || !toDate) {
        throw new Error(`Invalid dates for "${field.elementName}"`);
      }

      await agent.Restoration.AllowTitleDashboardReport({
        itemId,
        fromDate,
        toDate,
      });
    }
  };

  useEffect(() => {
    if (metaDataVal !== undefined && metaDataVal?.metadata !== undefined) {
      metaDataVal?.metadata.sort((a: any, b: any) => {
        return a.index - b.index;
      });
      setSelectedId(metaDataVal.physical_location_vault);
    }
    // eslint-disable-next-line
  }, [metaDataVal]);

  useEffect(() => {
    let metadataPayload: string[] = [];
    let technicalPayload: string[] = [];
    localMetaData?.metadata?.forEach((data: any) => {
      if (data?.metadatatype === 'Technical') {
        technicalPayload.push(data.elementId);
      } else if (data?.metadatatype === 'Metadata') {
        metadataPayload.push(data.elementId);
      }
    });

    setMetadataExistence(metadataPayload);
    setTechnicalExistence(technicalPayload);
    // eslint-disable-next-line
  }, [localMetaData?.metadata]);

  const getUploadedFiles = (uploadedFiles: FileType, index: number) => {
    let temp: any = [];
    if (uploadedFiles?.id !== '') {
      temp = [...localMetaData.metadata];
      temp[index]?.files.push(uploadedFiles);
      setLocalMetaData({
        ...localMetaData,
        metadata: temp,
      });
    }
  };

  const getUploadedPhotos = (uploadedPhotos: PhotoType, index: number) => {
    let temp: any = [];
    if (uploadedPhotos?.id !== '') {
      temp = [...localMetaData.metadata];
      temp[index]?.photos.push(uploadedPhotos);
      setLocalMetaData({
        ...localMetaData,
        metadata: temp,
      });
    }
  };

  const onPhotoClick = (index: number) => {
    setPhotoIndex(index);
    dashboardStore.setOpenCameraModal(true);
  };

  const returnTitleFunctionForParent = async (id: string, type: string) => {
    try {
      if (id) {
        let item: any = await agent.Activities.details(id);
        if (type === 'Multiple') {
          setParentTitle(item.title);
        } else {
          setParentTitleSingle(item.title);
        }
      }
    } catch {
      console.log('Error');
    }
  };

  const completeHandler = (id: string) => {
    if (isMaster) {
      history(`/mastersreport/${isMaster}`);
    } else history(`/mediaAssets/${id}`);
  };

  const saveMetaDataChanges = async () => {
    setIsSaveClicked(true);
    let formDetails: {
      id: any;
      description: string;
      values: string;
      type: string;
    }[] = [];
    let metadataCopy = { ...localMetaData };
    if (metadataCopy['calculated_category'] === '') {
      metadataCopy['calculated_category'] = 0;
    }

    if (JSON.stringify(metaDataVal) === JSON.stringify(metadataCopy)) {
      toast.info('Kindly make changes to the item to get it submitted');
      return;
    }
    if (metadataCopy?.title?.length === 0) {
      let element = document.getElementById('title');
      element?.focus();
      toast.info('Kindly fill appropriate input');
      return;
    }
    if (Object.keys(errorMessage)?.length) {
      let element = document.getElementById(Object.keys(errorMessage)[0]);
      // if(element) element.tabIndex = -1;
      element?.focus();
      let x = (Object.values(errorMessage)?.[0] as string) || '';
      toast.info(x);
      return;
    }
    // form details
    let keys: string[] = Object.keys(metadataCopy);
    const filteredArrayExceptMetadata = keys?.flatMap((key) => {
      if (!Array.isArray(metadataCopy?.[key])) {
        if (
          JSON.stringify(metaDataVal[key]) !== JSON.stringify(metadataCopy[key])
        ) {
          return {
            id: '',
            description: key,
            values: metadataCopy[key],
            type: '',
          };
        } else return [];
      } else return [];
    });

    let isMandatory = false;
    let metadataKeys = metadataCopy?.metadata;

    const filteredMetadata = metadataKeys?.flatMap((data: any, i: number) => {
      //current user update
      if (
        data.elementType?.includes('CurrentUser') &&
        data.elementValue === '' &&
        data.mode !== 2
      ) {
        const autoVal = data.elementType.split('|')?.[1];
        switch (autoVal) {
          case 'displayNameWithTimeStamp':
            data.elementValue = `By ${userStore?.user
              ?.displayName} on ${new Date()}`;
            break;
          case 'timeStamp':
            data.elementValue = new Date().toString();
            break;
          default:
            data.elementValue =
              userStore?.user?.[autoVal as string as keyof GetCurrentUser];
            break;
        }
      }
      if (data.elementType === 'DatePicker' && data.elementValue === '') {
        data.elementValue = new Date().toLocaleDateString('en-IN', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        });
      }
      // mandatory fields checking
      if (mandatoryFieldsRef.current[`${data.elementId}`]) {
        let localErrMsg = Object.assign({}, errorMessage);
        localErrMsg[`${data.elementId}`] = 'This is mandatory field';
        isMandatory = true;
        setErrorMessage(localErrMsg);
        let element = document.getElementById(data.elementId);
        element?.focus();
      }
      const foundElement = metadataValueUpdate.find(
        (element: any) => element.elementValue === data.elementValue,
      );
      if (data?.elementValue !== foundElement?.elementValue)
        return {
          id: data.elementId,
          description: data.elementName,
          values: data.elementValue,
          type: data.elementType,
        };
      else return [];
    });

    if (isMandatory) {
      let element = document.getElementById(
        Object.keys(mandatoryFieldsRef.current)[0],
      );
      element?.focus();
      let x = (Object.values(mandatoryFieldsRef.current)?.[0] as string) || '';
      toast.info(x);
      return;
    }

    formDetails = [...filteredArrayExceptMetadata, ...filteredMetadata];
    if (userStore.user !== null) {
      const titleProcessPayload = titleProcessDates.filter(
        (item) => item.fromDate || item.toDate,
      );
      const titleProcessItemId =
        localMetaData?.id || selectedActivity?.id || id || '';

      if (isEditForm) {
        if (titleProcessPayload.length) {
          if (!titleProcessItemId) {
            toast.error('Unable to send Titleprocess dates: item id is missing');
            return;
          }
          await submitTitleProcessData(titleProcessItemId, titleProcessPayload);
        }

        if (commonStore.NFAIReportCustomer) {
          // Length-Meters/Feet (as per CBFC) metadata update
          const element = metadataCopy.metadata.find(
            (e: any) => e.elementName === 'Length-Meters/Feet (as per CBFC)',
          );
          if (element && element.elementValue)
            element.elementValue = element.elementValue
              .replace('mt', 'Meters')
              ?.replace('Mts', 'Meters')
              .replace('ft', 'Feet');
        }
        updateMetaData(metadataCopy, History, history).then(() => {
          sendRespectiveEmail('edited', '', 'Edited Asset', '');
          workflowHistoryHandler(
            formDetails,
            removedRow || [],
            addedRow || [],
            // alteredRowHistory,
            dataGridInitialValue,
            dataGridHeaders,
          );
          // formDetails?.forEach((data) => {
          //   let message = `${user?.displayName} set ${data.name} as "${data.value}"`;
          //   commonStore.updateHistoryAlonePOST(
          //     message,
          //     metadataCopy?.id || '',
          //     completeHandler,
          //     false,
          //   );
          // });
        });
      } else {
        for (let i = 0; i < metadataCopy.metadata?.length; i++) {
          metadataCopy.metadata[i].elementId = uuid();
        }
        if (id) {
          createManageDetailsAPI(metadataCopy, id).then(async (data) => {
            const itemId = data?.id || id;
            if (titleProcessPayload.length && itemId) {
              await submitTitleProcessData(itemId, titleProcessPayload);
            }
            let message = `Item ${data?.title} created successfully by ${user?.displayName}`;
            sendRespectiveEmail('edited', '', 'Edited Asset', '');
            // updateViewAssignUser(
            //   metadataCopy?.id || '',
            //   userStore.user?.id || '',
            // );
            await agent.viewPage.addUserToItem({
              itemId: metadataCopy?.id,
              userId: userStore.user?.id,
            });
            commonStore.updateHistoryAlonePOST(
              message,
              metadataCopy?.id || '',
              completeHandler,
              false,
            );
          });
        }
      }
    }
  };

  const onConfirmUser = async (validationData: any) => {
    let copyElements = [...localMetaData];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    // let previousValue = copyElements[indexOfData]?.elementValue || '';
    let errorTemp = Object.assign({}, errorMessage);
    let result = '';
    let payload = {
      ...validationData,
      // Only for datepicker "e" is consider as a value
      elementValue: userStore.user?.displayName,
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      if (copyElements[indexOfData]) {
        copyElements[indexOfData] = payload;
      }
    }
    if (validationData?.isMandatory) {
      result = 'This is mandatory field';
    }
    if (result) {
      errorTemp[`${validationData?.elementId}`] = result;
      mandatoryFieldsRef.current[`${validationData?.elementId}`] =
        validationData?.elementId;
    } else {
      delete errorTemp[`${validationData?.elementId}`];
      delete mandatoryFieldsRef.current[`${validationData?.elementId}`];
    }
    setErrorMessage(errorTemp);
    setLocalMetaData(copyElements);
  };

  const addToItemFiles = async (blobFile: Blob, fileName: string) => {
    let response;
    let addFilesPayload: uploadFileType = { id: '', files: [] };
    var file = new File([blobFile], fileName);
    if (commonStore.devEnv) {
      const workLevel = 'Tag PDF';
      response = await agent.Files.localFileUpload(file, workLevel, id || '');
      const url = response.data.path.replace(/\\\\/g, '\\');
      const filename = url.substring(url.lastIndexOf('\\') + 1);
      addFilesPayload = {
        id: id || '',
        files: [
          {
            id: uuid(),
            fileId: response.data.id,
            fileName: filename,
            url: url,
            addedOn: new Date(),
          },
        ],
      };
      dashboardStore.getLocalFilesBasedOnItem(id || '');
    } else {
      response = await agent.Files.uploadFile(file);
      addFilesPayload = {
        id: id || '',
        files: [{ ...response.data, addedOn: new Date() }],
      };
    }
    await generatePdf(addFilesPayload);
  };

  const renderComponents = (metadata: any[], isCheckboxOrParent: boolean) => {
    return metadata
      ?.filter((e: any) => isCheckboxOrParent 
        ? e.elementType === 'Checkbox' || e.elementType === 'Parent' 
        : e.elementType !== 'Checkbox' && e.elementType !== 'Parent')
      .map((elem: any, index: number) => 
        metadataExistence.includes(elem.elementId) &&
        !commonStore.filterModeTwo?.includes(elem.templateElementId) && (
          <Components
            key={index}
            disabled={commonStore.filterModeZero?.includes(elem.templateElementId)}
            index={index}
            elementDetails={elem}
            addPhotographsHandler={() => dashboardStore.setOpenCameraModal(true)}
            onChangeHandler={collectSelectInpVal}
            camImage={camImage}
            masterOptions={(elem.elementType === 'Masters' && 
              mastersList[elem.elementValue?.toString()?.split('|')?.[0] || '']) || []}
            usersOptions={(elem.elementType === 'Users' && 
              userList[elem.elementValue?.toString()?.split('|')?.[0] || '']) || []}
            errorMessage={isSaveClicked ? errorMessage : ''}
            mastersHandler={(e: SyntheticEvent, data: any) => mastersAndUsersHandler(e, data)}
            usersHandler={(e: SyntheticEvent, data: any) => mastersAndUsersHandler(e, data)}
            onPhotoClick={() => onPhotoClick(index)}
            getUploadedFiles={getUploadedFiles}
            RoleChecker={true}
            onConfirmUser={onConfirmUser}
            saveDynamicTableData={saveDynamicTableData}
          />
        )
      );
  };
  
  return (
    <>
      {dashboardStore.dashboard.openCameraModal ? (
        <CamModal getUploadedPhotos={getUploadedPhotos} index={photoIndex} />
      ) : null}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('AVLAVB01') && (
          <UnauthorizedMessage />
        )}

      {Object.keys(localMetaData)?.length > 0 ? (
        commonStore.filterModeOne?.includes('AVLAVB01') ? (
          <Segment
            clearing
            style={{
              padding: '10px',
              marginLeft: '1em',
              marginRight: '1em',
              marginBottom: '90px',
            }}
          >
            <Header
              clearing
              style={{ marginBottom: '15px' }}
              icon="edit"
              size="huge"
              dividing
              as="h1"
              content="Create/Edit Asset - work level metadata "
              sub
              color="grey"
            />
            <Button.Group floated="right" className="manage-asset-cta">
              {isEditForm && (
                <>
                  {commonStore.filterModeTwo?.includes('MAU01') ? (
                    <></>
                  ) : (
                    <Button
                      positive
                      type="button"
                      onClick={() => updateMetaDataHandler(localMetaData?.id)}
                      className="btn1"
                      disabled={commonStore.filterModeZero?.includes('MAU01')||
                      loadingType === 'update'}
                    >
                      {loadingType === 'update' && <Icon name="spinner" loading />}
                      {loadingType === 'update' ? 'updating...' : 'update'}
                    </Button>
                  )}
                  {commonStore.filterModeTwo?.includes('MAD01') ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        floated="right"
                        color="red"
                        type="button"
                        content="Delete"
                        disabled={commonStore.filterModeZero?.includes('MAD01')}
                        onClick={handleDeleteActivity}
                        className="btn2"
                      />
                      {/* <Button.Or /> */}
                    </>
                  )}
                </>
              )}
              {commonStore.filterModeTwo?.includes('MAE01') ? (
                <></>
              ) : (
                <Button
                  floated="right"
                  type="button"
                  content="Cancel"
                  disabled={commonStore.filterModeZero?.includes('MAE01')}
                  onClick={cancelHandler}
                  className="btn3"
                />
              )}
              {commonStore.filterModeTwo?.includes('MAE01') ||
              commonStore.filterModeTwo?.includes('MAS01') ? (
                <></>
              ) : (
                <Button.Or />
              )}
              {commonStore.filterModeTwo?.includes('MAS01') ? (
                <></>
              ) : (
                <Button
                  floated="right"
                  positive
                  type="submit"
                  content={user?.customerName === 'NFAIReport' ? 'Save' : 'Submit'}
                  disabled={commonStore.filterModeZero?.includes('MAS01')}
                  onClick={saveMetaDataChanges}
                  className="btn4"
                />
              )}
            </Button.Group>
            <Segment color="teal" style={{ marginTop: '60px' }}>
              <Header
                icon="suitcase"
                content="Asset Details"
                sub
                color="blue"
              />
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    required
                    disabled={commonStore.NFAIReportCustomer || commonStore.RestorationCustomer}
                    placeholder="Title"
                    label="Title"
                    name="Title"
                    value={localMetaData?.title}
                    style={{ width: '100%', marginTop: '5px' }}
                    onChange={(e: SyntheticEvent, data: any) =>
                      collectFormInput(e, data)
                    }
                    id="title"
                  />
                  {!isMaster && (
                    <>
                      <Form.Field
                        control={Input}
                        placeholder="Thumbnail"
                        label="Thumbnail"
                        name="Thumbnail"
                        value={localMetaData?.thumbnail}
                        style={{
                          width: '100%',
                          marginTop: '5px',
                        }}
                        onChange={(e: SyntheticEvent, data: any) => {
                          collectFormInput(e, data);
                        }}
                        id="thumbnail"
                      />
                      <Form.Field
                        control={Input}
                        placeholder="Preview"
                        label="Preview"
                        name="Preview"
                        value={localMetaData?.preview}
                        style={{
                          width: '100%',
                          marginTop: '5px',
                        }}
                        onChange={(e: SyntheticEvent, data: any) => {
                          collectFormInput(e, data);
                        }}
                        id="preview"
                      />
                      <Form.Field
                        control={Input}
                        placeholder="Proxy"
                        label="Proxy"
                        name="Proxy"
                        value={localMetaData?.proxy}
                        style={{
                          width: '100%',
                          marginTop: '5px',
                        }}
                        onChange={(e: SyntheticEvent, data: string) => {
                          collectFormInput(e, data);
                        }}
                        id="proxy"
                      />
                    </>
                  )}
                </Form.Group>
                {
                  commonStore.hfcCustomerChanges && (
                    <Form.Group widths="equal">
                      <Form.Field
                      control={Input}
                      placeholder="Asset Id"
                      label="Asset Id"
                      name="Asset Id"
                      value={localMetaData?.assetId}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: string) => {
                        collectFormInput(e, data);
                      }}
                      id="assetId"
                    />
                    <Form.Field
                      control={Input}
                      placeholder="Print"
                      label="Print"
                      name="Print"
                      value={localMetaData?.print}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: string) => {
                        collectFormInput(e, data);
                      }}
                      id="print"
                    />
                    <Form.Field/>
                    <Form.Field/>
                  </Form.Group>
                )
                }
              </Form>
            </Segment>
            {user?.displayName === 'E1401' && titleProcessDates.length > 0 && (
              <Segment className="metadata-mobile-manage-asset" color="teal">
                <Header
                  icon="calendar alternate"
                  content="Title Dashboard Dates"
                  sub
                  color="blue"
                />
                <Form>
                  {titleProcessDates.map((field) => (
                    <Form.Group widths="equal" key={field.elementId}>
                      <Form.Field
                        control={Input}
                        type="datetime-local"
                        label={`${field.elementName} From Date`}
                        value={field.fromDate}
                        onChange={(e: SyntheticEvent, data: any) =>
                          handleTitleProcessDateChange(
                            field.elementId,
                            'fromDate',
                            data.value,
                          )
                        }
                        style={{ width: '100%', marginTop: '5px' }}
                        id={`titleprocess-from-${field.elementId}`}
                      />
                      <Form.Field
                        control={Input}
                        type="datetime-local"
                        label={`${field.elementName} To Date`}
                        value={field.toDate}
                        onChange={(e: SyntheticEvent, data: any) =>
                          handleTitleProcessDateChange(
                            field.elementId,
                            'toDate',
                            data.value,
                          )
                        }
                        style={{ width: '100%', marginTop: '5px' }}
                        id={`titleprocess-to-${field.elementId}`}
                      />
                    </Form.Group>
                  ))}
                </Form>
              </Segment>
            )}
            {!!metadataExistence?.length && (
              <>
              {<Segment className="metadata-mobile-manage-asset" color="teal">
                <Header icon="suitcase" content="MetaData" sub color="blue" />
                <Form>
                  <Grid
                    style={{
                      marginTop: '20px',
                      display: 'grid',
                      gridTemplateColumns:
                        'repeat(auto-fit, minmax(300px , 1fr))',
                    }}
                  >
                    {user?.customerName === 'PCPLCRM' ? null :localMetaData?.metadata
                    ?.map(
                      (elem: any, index: number) =>
                        metadataExistence.includes(elem.elementId) &&
                        !commonStore.filterModeTwo?.includes(
                          elem.templateElementId,
                        ) && (
                          <>
                            <Components
                              disabled={commonStore.filterModeZero?.includes(
                                elem.templateElementId,
                              )}
                              index={index}
                              elementDetails={elem}
                              addPhotographsHandler={() =>
                                dashboardStore.setOpenCameraModal(true)
                              }
                              onChangeHandler={collectSelectInpVal}
                              camImage={camImage}
                              // classNameFunc={classNamdeFunc}
                              masterOptions={
                                (elem.elementType === 'Masters' &&
                                  mastersList[
                                    `${
                                      elem.elementValue
                                        ?.toString()
                                        ?.split('|')?.[0] || ''
                                    }`
                                  ]) ||
                                []
                              }
                              usersOptions={
                                (elem.elementType === 'Users' &&
                                  userList[
                                    `${
                                      elem.elementValue
                                        ?.toString()
                                        ?.split('|')?.[0] || ''
                                    }`
                                  ]) ||
                                []
                              }
                              errorMessage={isSaveClicked ? errorMessage : ''}
                              mastersHandler={(e: SyntheticEvent, data: any) =>
                                mastersAndUsersHandler(e, data)
                              }
                              usersHandler={(e: SyntheticEvent, data: any) =>
                                mastersAndUsersHandler(e, data)
                              }
                              onPhotoClick={() => onPhotoClick(index)}
                              getUploadedFiles={getUploadedFiles}
                              RoleChecker={true}
                              onConfirmUser={onConfirmUser}
                              saveDynamicTableData={saveDynamicTableData}
                            />
                          </>
                        ),
                        
                    )}
                    {/* {localMetaData?.metadata?.length <= 0 ? (
                    <Header style={{ marginLeft: "100px", padding: "20px" }}>
                      No Metadata found
                    </Header>
                  ) : null} */}
                  </Grid>
                  {user?.customerName === 'PCPLCRM' ?  <>
                    <Grid style={{
                      marginTop: '20px',
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(300px , 1fr))'
                    }}>
                      {renderComponents(localMetaData?.metadata, false)}
                    </Grid>
                    <Grid>
                      {renderComponents(localMetaData?.metadata, true)}
                    </Grid>
                  </> : null}
                </Form>
              </Segment>}
              </>
            )}
            {!!technicalExistence.length && (
              <Segment className="metadata-mobile-manage-asset" color="teal">
                <Header icon="suitcase" content="Technical" sub color="blue" />
                <Form style={{ marginTop: '0px' }}>
                  <Grid
                    style={{
                      marginTop: '20px',
                      display: 'grid',
                      gridTemplateColumns:
                        'repeat(auto-fit, minmax(300px , 1fr))',
                    }}
                  >
                    {localMetaData?.metadata?.map(
                      (elem: any, index: number) =>
                        technicalExistence.includes(elem.elementId) &&
                        !commonStore.filterModeTwo?.includes(
                          elem.templateElementId,
                        ) && (
                          <Components
                            disabled={commonStore.filterModeZero?.includes(
                              elem.templateElementId,
                            )}
                            index={index}
                            elementDetails={elem}
                            addPhotographsHandler={() =>
                              dashboardStore.setOpenCameraModal(true)
                            }
                            onChangeHandler={collectSelectInpVal}
                            camImage={camImage}
                            // classNameFunc={classNamdeFunc}
                            masterOptions={
                              (elem.elementType === 'Masters' &&
                                mastersList[
                                  `${
                                    elem.elementValue
                                      ?.toString()
                                      ?.split('|')?.[0] || ''
                                  }`
                                ]) ||
                              []
                            }
                            usersOptions={
                              (elem.elementType === 'Users' &&
                                userList[
                                  `${
                                    elem.elementValue
                                      ?.toString()
                                      ?.split('|')?.[0] || ''
                                  }`
                                ]) ||
                              []
                            }
                            errorMessage={isSaveClicked ? errorMessage : ''}
                            mastersHandler={(e: SyntheticEvent, data: any) =>
                              mastersAndUsersHandler(e, data)
                            }
                            usersHandler={(e: SyntheticEvent, data: any) =>
                              mastersAndUsersHandler(e, data)
                            }
                            onPhotoClick={() => onPhotoClick(index)}
                            getUploadedFiles={getUploadedFiles}
                            onConfirmUser={onConfirmUser}
                            saveDynamicTableData={saveDynamicTableData}
                          />
                        ),
                    )}
                    {localMetaData?.metadata?.length === 0 ? (
                      <Header
                        style={{
                          marginLeft: '100px',
                          padding: '20px',
                        }}
                      >
                        No Technical Details found
                      </Header>
                    ) : null}
                  </Grid>
                </Form>
              </Segment>
            )}
            {!isMaster && (
              <Segment color="teal">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Header
                    icon="film"
                    content="Physical Assets"
                    sub
                    color="violet"
                  />
                  {commonStore.hfcCustomerChanges && (
                    <PDFDownloadLink
                      document={<TagVerifyPDF tagDetails={tagPDFData} />}
                      // document={<></>}
                      fileName="TagVerify.pdf"
                      className="genRep"
                    >
                      {({ blob, url, loading, error }) => (
                        <Button
                          onClick={() => addToItemFiles(blob!, 'TagVerify.pdf')}
                          color="blue"
                          disabled={true}
                        >
                          Download
                        </Button>
                      )}
                    </PDFDownloadLink>
                  )}
                </div>

                <Form>
                  <Form.Group widths="equal">
                    {!commonStore.hfcCustomerChanges  ? (
                    <>
                    <Form.Field
                      control={Input}
                      placeholder="Physical Sensor NFC"
                      label="Physical Sensor NFC"
                      name="Physical Sensor NFC"
                      value={localMetaData?.physical_sensor_NFC}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="physical_sensor_NFC"
                    />
                    <Form.Field
                      control={userStore?.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName === 'IT Team' ? TextArea : Input}
                      placeholder={"Physical Sensor BarCode"}
                      label={userStore?.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName === 'IT Team' ? "BarCode" : "Physical Sensor BarCode"}
                      name={"Physical Sensor BarCode"}
                      value={localMetaData?.physical_sensor_barcode}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="physical_sensor_barcode"
                    />
                    <Form.Field
                      control={userStore?.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName === 'IT Team' ? TextArea : Input}
                      placeholder="Physical Sensor QR Code"
                      label={userStore?.user?.customerName === 'PCPLCRM' && userStore?.user?.roleName === 'IT Team' ? "QR Code" : "Physical Sensor QR Code"}
                      name="Physical Sensor QR Code"
                      value={localMetaData?.physical_sensor_qrcode}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="physical_sensor_qrcode"
                    />
                    <Form.Field
                      control={Input}
                      placeholder="Physical Sensor RFID"
                      label="Physical Sensor RFID"
                      name="Physical Sensor RFID"
                      value={localMetaData?.physical_sensor_RFID}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="physical_sensor_RFID"
                    />
                    </>) : 
                   (
                    <>
                      <Form.Field
                      control={Input}
                      placeholder="Container Barcode"
                      label="Container Barcode"
                      name="Container Barcode"
                      value={localMetaData?.container_Barcodes}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="container_Barcodes"
                      />
                      <Form.Field
                      control={Input}
                      placeholder="Reel Barcode"
                      label="Reel Barcode"
                      name="Reel Barcode"
                      value={localMetaData?.reel_Barcodes}
                      style={{
                        width: '100%',
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="reel_Barcodes"
                      />
                    </>
                   )
                  }
                  </Form.Group>
                  <Form.Group widths="equal">
                    {
                      commonStore.hfcCustomerChanges ? (
                        <>
                          <Form.Field
                            control={Select}
                            search 
                            clearable
                            label="Vault"
                            name="Vault"
                            placeholder="Vault"
                            value={localMetaData?.vault}
                            style={{
                              width: '100%',
                              marginTop: '5px',
                            }}
                            onChange={(e: SyntheticEvent, data: any) => {
                              collectFormInput(e, data);
                            }}
                            options={vaultStore.HFCvaultList}
                            id="vault"
                            />
                            <Form.Field
                            id="room"
                            control={Select}
                            placeholder="Room"
                            label="Room"
                            name="Room"
                            value={localMetaData?.room}
                            search
                            clearable
                            style={{
                              width: '100%',
                              marginTop: '5px',
                            }}
                            onChange={(e: SyntheticEvent, data: any) => {
                              collectFormInput(e, data);
                            }}
                            options={roomOptions}
                            />
                        <Form.Field
                          control={Select}
                          label="Aisle No"
                          search
                          clearable
                          placeholder="Aisle No"
                          name="Aisle No"
                          // type="number"
                          onChange={(e: SyntheticEvent, data: any) =>
                            collectFormInput(e, data)
                          }
                          value={localMetaData?.aisle_No}
                          id="aisle_No"
                          options={aisleOptions}
                          style={{ marginTop: '5px' }}
                        />
                        </>
                      ):(
                        <>
                          <Form.Field
                      control={Select}
                      options={vaultOptions}
                      label={
                        user?.customerName === 'LVP CMS - AM'
                          ? 'Physical Location Room'
                          : 'Physical Location Vault'
                      }
                      placeholder={
                        user?.customerName === 'LVP CMS - AM'
                          ? 'Physical Location Room'
                          : 'Physical Location Vault'
                      }
                      name="Physical Location Vault"
                      search
                      clearable
                      onChange={(e: SyntheticEvent, data: any) =>
                        collectFormInput(e, data)
                      }
                      value={localMetaData?.physical_location_vault}
                      id="physical_location_vault"
                      style={{ marginTop: '5px' }}
                    />
                    <Form.Field
                      control={Select}
                      options={rackOptions}
                      placeholder="Physical Location Rack"
                      label="Physical Location Rack"
                      name="Physical Location Rack"
                      search
                      clearable
                      value={localMetaData?.physical_location_rack}
                      style={{
                        marginTop: '5px',
                      }}
                      onChange={(e: SyntheticEvent, data: any) => {
                        collectFormInput(e, data);
                      }}
                      id="physical_location_rack"
                    />
                    <Form.Field
                      control={Select}
                      options={shelfOptions}
                      label="Physical Location Shelf"
                      placeholder="Physical Location Shelf"
                      name="Physical Location Shelf"
                      search
                      clearable
                      onChange={(e: SyntheticEvent, data: any) =>
                        collectFormInput(e, data)
                      }
                      value={localMetaData?.physical_location_shelf}
                      id="physical_location_shelf"
                      style={{ marginTop: '5px' }}
                    />
                    </>
                      )
                    }
                    
                    {commonStore.hfcCustomerChanges ? (
                      <>
                      <Form.Field
                            control={Select}
                            search
                            clearable
                            placeholder="Shelf"
                            label="Shelf"
                            name="Shelf"
                            value={localMetaData?.shelf}
                            style={{
                              width: '100%',
                              marginTop: '5px',
                            }}
                            onChange={(e: SyntheticEvent, data: any) => {
                              collectFormInput(e, data);
                            }}
                            id="shelf"
                            options={shelfOptions}
                            />
                      </>
                    ) : user?.customerName !== 'PCPLCRM' && user?.roleName !== 'IT Team' ? (
                      <>
                        <Form.Field
                          control={Input}
                          label="Physical Case Count"
                          placeholder="Physical Case Count"
                          name="Physical Case Count"
                          type="number"
                          onChange={(e: SyntheticEvent, data: any) =>
                            collectFormInput(e, data)
                          }
                          value={localMetaData?.calculated_category}
                          id="calculated_category"
                          style={{ marginTop: '5px' }}
                        />
                        <Form.Field
                          clearable
                          search
                          selection
                          options={pigeonList}
                          id="synopsis"
                          label={'Pigeon Hole'}
                          control={Select}
                          placeholder={'Pigeon Hole'}
                          onChange={(e: SyntheticEvent, data: any) =>
                            collectFormInput(e, data)
                          }
                          value={localMetaData?.synopsis!}
                          style={{ marginTop: '5px' }}
                        />
                      </>
                    ) : null}
                    {user?.customerName !== 'PCPLCRM' && user?.roleName !== 'IT Team' && vaultList.map((vaultdata) => {
                      return (
                        <>
                          {selectedId === vaultdata.name && (
                            <Form.Field
                              control={Input}
                              placeholder="Global Positioning System"
                              onChange={(e: SyntheticEvent, data: any) => {
                                collectFormInput(e, data);
                              }}
                              label="Global Positioning System"
                              name="Global Positioning System"
                              defaultValue={vaultdata?.gpsLocation}
                              style={{
                                width: '100%',
                                marginTop: '5px',
                              }}
                              id="global_positioning_system"
                              disabled={vaultdata?.gpsLocation !== ''}
                            />
                          )}
                        </>
                      );
                    })}
                  </Form.Group>
                </Form>
                <Grid style={{ padding: '10px' }}>
                  <Grid.Row columns={2}>
                    {localMetaData.sections_Multiple_From !== null &&
                    localMetaData.sections_Multiple_From !== '' &&
                    localMetaData.sections_Multiple_From !== undefined ? (
                      <label
                        style={{
                          flexBasis: '50%',
                          padding: '10px',
                        }}
                      >
                        Parent Multiple
                        <Link
                          to={`/mediaAssets/${localMetaData.sections_Multiple_From}`}
                        >
                          <div className="ui input" style={{ color: 'red' }}>
                            <input
                              placeholder="Sections Multiple From"
                              style={{
                                color: '#52a0db',
                              }}
                              type="text"
                              value={parentTitle}
                            />
                          </div>
                        </Link>
                      </label>
                    ) : null}
                    {localMetaData.sections_From !== null &&
                    localMetaData.sections_From !== '' &&
                    localMetaData.sections_From !== undefined ? (
                      <label
                        style={{
                          flexBasis: '50%',
                          padding: '10px',
                        }}
                      >
                        Parent Single
                        <Link
                          to={`/mediaAssets/${localMetaData.sections_From}`}
                        >
                          <div className="ui input" style={{ color: 'red' }}>
                            <input
                              placeholder="Sections Single From"
                              style={{
                                color: '#52a0db',
                              }}
                              type="text"
                              value={parentTitleSingle}
                            />
                          </div>
                        </Link>
                      </label>
                    ) : null}
                  </Grid.Row>
                </Grid>
              </Segment>
            )}
            {isEditForm && (
              !commonStore.hfcCustomerChanges ?
              (<Form.Group widths="equal" style={{ marginBottom: '40px' }}>
                {isMaster ? (
                  <HistoryTable />
                ) : (
                  <Grid columns={2}>
                    <Grid.Column>
                      <HistoryTable />
                    </Grid.Column>
                    <Grid.Column>
                      <OrderTable />
                    </Grid.Column>
                  </Grid>
                )}
              </Form.Group>) :null
            )}
          </Segment>
        ) : null
      ) : (
        <LoadingComponent />
      )}
    </>
  );
});
